import EventGrid from './EventGrid';

export default EventGrid;
